export enum HeaderType {
	LoanApplication = 'LoanApplication',
	LoanOffer = 'LoanOffer',
	LoanOfferTopUp = 'LoanOfferTopUp',
	CreditCardOffer = 'CreditCardOffer',
	None = 'None',
}
